import "./Tuyendung.css";
import { Phone } from 'lucide-react';

export default function Navbar() {
  return (
    <nav className="mainnav">
      <div className="wrap nav-inner">
        <div className="brand">
          <span className="brand-mark"><Phone size={18} fill="currentColor" /></span>
          <span>
            Tuyển Dụng Tư Vấn Viên
            <small>Việc làm online · Tìm việc nhanh</small>
          </span>
        </div>
        <a href="#apply" className="nav-cta">Ứng tuyển ngay</a>
      </div>
    </nav>
  );
}